export const createInvitationQrDataUrl = async (value, style, image = null) => {
  if (typeof window === 'undefined' || !value) return '';

  const { default: QRCodeStyling } = await import('qr-code-styling');
  let safeImage = image;
  if (image && /^https?:\/\//i.test(image) && !image.startsWith(window.location.origin)) {
    safeImage = `/api/invitation-avatar?url=${encodeURIComponent(image)}`;
  }
  const qr = new QRCodeStyling({
    width: 280,
    height: 280,
    type: 'canvas',
    data: value,
    margin: 10,
    qrOptions: { errorCorrectionLevel: 'H' },
    dotsOptions: {
      type: style.dotType,
      color: style.dark,
    },
    cornersSquareOptions: {
      type: style.cornerType,
      color: style.dark,
    },
    cornersDotOptions: {
      type: style.cornerType === 'dot' ? 'dot' : 'square',
      color: style.dark,
    },
    backgroundOptions: { color: style.light },
    image: style.useImage ? safeImage || undefined : undefined,
    imageOptions: {
      hideBackgroundDots: true,
      imageSize: 0.22,
      margin: 5,
      crossOrigin: 'anonymous',
    },
  });
  const blob = await qr.getRawData('png');

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};
